import React from 'react'

import SVGIcon from 'src/components/svg'
import BaseComponent from 'src/components/BaseComponent'

import { lang } from 'src/helpers';

export class JourneyList extends BaseComponent {
  componentDidMount () {
    this.getModel().baseSubscribe(this.subscription)
  }

  componentWillUnmount () {
    this.getModel().unsubscribe(this.subscription)
  }

  getModel = () => this.props.model

  render () {
    const { journeyCloseBtn, forAll = true, journeys = [], journeyId, journey } = this.props;
    const model = this.getModel()
    if (!journeyId) return null;
    return forAll || journeyId === 'timeline' ? <div
      className={`mc-categories`}
      id={'mc-categories'}
    >
      <div
        onClick={() => {
          model.handleChange('journeyId', 'timeline')
          this.props.selectJourney({id: 'timeline'})
        }}
        className={'mc-category ' + (!journeyId || journeyId === 'timeline' ? 'active' : '')}
      >
        <SVGIcon iconname={'timeline-icon'}/>
        {lang.t('Timeline')}
      </div>
      {journeys.map((item, index) => (
        <div
          style={{ order: index }}
          onClick={() => {
            this.props.selectJourney(item)
          }}
          className={'mc-category ' + (journeyId === item.id ? 'active' : '')}
          key={'category-' + item.id}
        >
          {item.cover && <img src={item.cover?.uri}/>}
          {item.title}
        </div>
      ))}
    </div> : <div className={'mc-category-active'}>
      {journeyCloseBtn}
      <div className={'mc-flex'}>
        {journey.cover && <img src={journey.cover?.uri}/>}
        <div className={'mc-value-624'}>{journey.title}</div>
      </div>
      <div className={'mc-label-420'}>{journey.description}</div>
    </div>
  }
}
